import React, { useCallback, useContext, useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import axios from "axios";
import { AuthContext, base_url } from "../../../context/Authcontext";
import { Link } from "react-router-dom";
import { data } from "jquery";
import ToastMessage from "../../ToastMessage";

const BrowseRecharge = () => {
  const {PaymentStatusMap} =useContext(AuthContext);
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [totalRecharge, setTotalRecharge] = useState(null);
  const [permit, setPermit]= useState([]);
  const { getRoles } = useContext(AuthContext);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  // Toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

// handle success recharge
const handleSuccessRech=async(id)=>{
  try{
    const auth=localStorage.getItem('admin');
    const res=await axios.post(`${base_url}/api/webapi/admin/recharge/status`,
      {id,status:PaymentStatusMap.SUCCESS},
      {
        withCredentials:true,
        headers:{
          Accept:"application/json",
          Authorization:`${auth}`
        }
      }
    );
    if(res.data.status){
      ToastMessage(1,res.data.message);
      const updatedRecharge = totalRecharge.filter((item) => item.id !== id);
      setTotalRecharge(updatedRecharge);
    }else{
      ToastMessage(0,res.data.message);
    }
  }catch(err){
    ToastMessage(0,"error");
  }
}
const handleCancelRecharge=async(id)=>{
  try{
    const auth=localStorage.getItem('admin');
    const res =await axios.post(`${base_url}/api/webapi/admin/recharge/status`,
      {id,status:PaymentStatusMap.CANCELLED},
      {
        withCredentials:true,
        headers:{
          Accept:'application/json',
          Authorization:`${auth}`
        }
      }
    )
    if(res.data.status){
      ToastMessage(1,res.data.message);
      const updatedRecharge = totalRecharge.filter((item) => item.id !== id);
      setTotalRecharge(updatedRecharge);
    }else{
      ToastMessage(0,res.data.message);
    }
  }catch(err){
   ToastMessage(0,"error"); 
  }
}

const fetchRoles= async ()=> {
  const auth= localStorage.getItem('admin');
  const role= localStorage.getItem('role');

  try{
    const roles= await getRoles(auth, role);

    roles.map((role)=>{

      const values= Object.values(role);

      values[0].map((val)=>{

        if(Object.keys(val).includes('pending recharge')){
          const permit= Object.values(val);

          setPermit(permit[0]);
        }
      })
      
    })
  }catch(error){
    console.log('ert',error);
  }
}
  useEffect(() => {
    const fetchRechargeRecord = async () => {
      try {
        const auth=localStorage.getItem('admin');
        const res = await axios.get(
          `${base_url}/api/webapi/admin/recharge/pending`,
          {
            withCredentials: true,
            headers: {
              Accept: "application/json",
              Authorization:`${auth}`
            },
          }
        );
        setTotalRecharge(res.data.list);
      } catch (err) {
        ToastMessage(0,'error');
      }
    };
    fetchRechargeRecord();
    fetchRoles();
  }, []);

    // console.log(permit);

    useEffect(() => {
      const handleResize = () => {
        const mobile = window.innerWidth < 768;
        setIsMobile(mobile);
        
        // On desktop, sidebar should always be "open"
        if (!mobile) {
          setIsSidebarOpen(true);
        }
      };
      
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

  return (
    <div className="wrapper">
      <AdminSidebar 
          isSidebarOpen={isSidebarOpen} 
          toggleSidebar={toggleSidebar} 
          isMobile={isMobile}
        />
        
        {/* Header - Pass mobile info */}
        <AdminHeader 
          toggleSidebar={toggleSidebar} 
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        />
        
        {/* Content Wrapper - Use conditional class and margin */}
        <div
          className={`content-wrapper ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
            transition: "margin-left 0.3s ease"
          }}
        >
        <div>
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1>Pending Recharge</h1>
                </div>
              </div>
            </div>
          </section>
          <section className="content">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">Pending Recharge</h3>
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="collapse"
                    title="Collapse"
                  >
                    <i className="fas fa-minus" />
                  </button>
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    title="Remove"
                  >
                    <i className="fas fa-times" />
                  </button>
                </div>
              </div>
              <div className="card-body p-0" style={{ overflowY: "hidden" }}>
                <table className="table table-striped projects">
                  <thead>
                    <tr>
                      <th className="text-center">#</th>
                      <th className="text-center">Account</th>
                     
                      <th className="text-center">Amount</th>
                      <th className="text-center">Code</th>
                      <th className="text-center">UTR</th>
                      <th className="text-center">Method</th>
                      <th className="text-center">Time</th>
                      <th className="text-center">Status</th>
                      <th className="text-center">Accept/Reject</th>
                    </tr>
                  </thead>
                  {totalRecharge?.map((e, i) => {
                    return (
                      <tbody key={i}>
                        <tr className="text-center">
                          <td>{e.id}</td>
                          <td>
                            <b>{e.phone}</b>
                          </td>
                          
                          <td>
                            <b>{e.money}</b>
                          </td>
                          <td style={{ minWidth: 190 }}>
                            <b>{e.id_order}</b>
                          </td>
                          <td style={{ minWidth: 190 }}>
                            <b>{e.utr}</b>
                          </td>
                          <td style={{ minWidth: 190 }}>
                          <b style={{ color: "#a50064" }}>{e.type}</b>
                          </td>
                          <td style={{ minWidth: 190 }}>
                            <b>{e.today}</b>
                          </td>
                          <td className="project-state">
                            <span className="badge badge-warning">
                              Waiting...
                            </span>
                          </td>
                          <td
                            className="d-flex gap-2 justify-content-center project-actions text-center"
                            style={{ minWidth: 160 }}
                          >
                            <Link
                              className={`btn btn-success btn-sm confirm-btn ${permit.includes('Accept Recharge')? 'd-block': 'd-none'}`}
                              
                              onClick={()=>handleSuccessRech(e.id)}
                            >
                              <i className="fa fa-check" />
                            </Link>
                            <Link
                              className={`btn btn-danger btn-sm delete-btn ${permit.includes('Reject Recharge')? 'd-block': 'd-none'}`}
                             
                              onClick={()=>handleCancelRecharge(e.id)}
                            >
                              <i className="fas fa-trash" />
                            </Link>
                          </td>
                        </tr>
                      </tbody>
                    );
                  })}
                </table>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default BrowseRecharge;
